var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autosize-image"},[_c('img',{ref:"autosizeImage",class:[_vm.className],attrs:{"src":_vm.src,"alt":""},on:{"load":_vm.bindLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }